import React from 'react';

const ConsentContent = () => {
	return (
		<>
			<h3 className="mb-5">Welcome to Cobalt</h3>
			<p className="mb-5">
				The content on COBALT-DH is curated by multidisciplinary health care providers. The aim of COBALT is to
				help employees navigate and access an extensive network of community support and behavioral health
				resources, as well as to provide resources that promote wellbeing and self-care. Some of the resources
				and materials here were created by Dartmouth Health Behavioral Health Solution while others were
				reviewed and approved by our multidisciplinary team for their scientific basis and utility.
			</p>
			<p className="mb-5">
				COBALT-DH is a platform for your wellness journey and education. While COBALT can also help connect you
				with providers, use of this site independently is for educational and support purposes only and does not
				substitute for treatment.
			</p>

			<h4 className="mb-5">On COBALT-DH you can...</h4>
			<ul className="mb-5">
				<li className="mb-2">
					Discover articles, videos, and resources that can help guide your wellness journey
				</li>
				<li className="mb-2">
					Find information guiding you to appropriate resources available to you as a DH employee
				</li>
				<li className="mb-2">Connect with navigators and mental health providers</li>
				<li className="mb-2">
					Locate child and family-friendly resources that address common areas of concern for today's families
				</li>
				<li className="mb-2">
					Engage with group experiences (trainings, live courses, education, therapy groups) that are safe,
					socially appropriate, and respectful of everyone's privacy
				</li>
				<li className="mb-2">Promote your own self-care</li>
			</ul>

			<h4 className="mb-5">COBALT-DH is not...</h4>
			<ul className="mb-5">
				<li className="mb-2">A substitute for clinical mental health or psychiatric treatment</li>
				<li className="mb-2">A Crisis Hotline or emergency service</li>
				<li className="mb-2">Staffed 24/7</li>
			</ul>
			<p className="mb-5">
				If you or a family member are in an emergency, call 911 or 988 (Suicide Crisis Line) or go to your
				nearest emergency room. COBALT-DH does not provide immediate-response crisis counseling or emergency
				services.
			</p>
			<p className="mb-5">
				Use of this platform is anonymous, although some areas of the website do require you log in (for
				instance, in order to access appointments). Use of the website and the mental health services are
				subject to standard HIPAA regulations, and at no point will information from this service be shared with
				your supervisor(s). Regardless of whether you use only the parts of the platform that offer full
				anonymity or access tools and resources that require log in, all information will remain private.
			</p>
			<p className="mb-5">
				Information that you share via this application will never be shared with any third-party, unless
				legally required through court order.
			</p>
			<p>
				Information that you share via this application will never be used for advertising purposes or shared
				with Dartmouth Health System as your employer.
			</p>
		</>
	);
};

export default ConsentContent;
